/**
 * 部署路径感知的静态资源工具。
 * 项目使用 hash 路由，页面 pathname 即部署基路径（本地/离线为 /，
 * 部署平台为 /page/amp-official-site/ 等子路径），据此为 public/assets
 * 下的资源拼接前缀，保证根路径与子路径部署均可正确加载。
 */

/** 部署基路径，如 '/' 或 '/page/amp-official-site/'（始终以 / 结尾） */
export const deployBase = window.location.pathname.replace(/[^/]*$/, '');

/** 将 '/assets/xxx' 或 'assets/xxx' 转换为带部署前缀的可访问 URL */
export function assetUrl(path: string): string {
  return deployBase + path.replace(/^\//, '');
}

/** 需要运行时注入的字体（CSS 中的 url() 无法感知部署子路径） */
const FONT_FACES: Array<{ family: string; file: string; style?: string }> = [
  { family: 'Poppins-Bold', file: 'assets/V2F8eUf-Poppins-Bold.ttf' },
  { family: 'Poppins-ExtraBold', file: 'assets/OQzoO9r-Poppins-ExtraBold.ttf' },
  { family: 'Poppins-SemiBold', file: 'assets/fXBS1Sj-Poppins-SemiBold.ttf' },
  { family: 'Poppins-Regular', file: 'assets/rL2i7o2-Poppins-Regular.ttf' },
  {
    family: 'Noto Sans',
    file: 'assets/Duah5xW-NotoSans-VariableFont_wdthwght.ttf',
  },
];

/** 注入 @font-face 规则，替代 LESS 中的静态声明 */
export function injectFontFaces(): void {
  const css = FONT_FACES.map(
    ({ family, file, style = 'normal' }) => `@font-face {
  font-family: '${family}';
  font-style: ${style};
  src: url('${assetUrl(file)}') format('truetype');
  font-display: swap;
}`,
  ).join('\n');
  const styleEl = document.createElement('style');
  styleEl.setAttribute('data-injected-fonts', 'true');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
}
